import { Toaster as Sonner } from "sonner";
import type { ToasterProps } from "sonner";
import { useTheme } from "../theme-provider";
import {
  CheckCircle,
  Close,
  DangerCircle,
  DangerTriangle,
  InfoCircle,
} from "@papier/ui/components/icons";
import { Spinner } from "@papier/ui/components/ui/spinner";

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      icons={{
        success: <CheckCircle className="size-5" />,
        info: <InfoCircle className="size-5" />,
        warning: <DangerTriangle className="size-5" />,
        error: <DangerCircle className="size-5" />,
        loading: <Spinner className="size-5" />,
        close: <Close className="size-3" />,
      }}
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
          "--border-radius": "0.75rem",
        } as React.CSSProperties
      }
      toastOptions={{
        classNames: {
          toast: "shadow-xl border-border/40 backdrop-blur-xl bg-popover/80 rounded-2xl",
          title: "font-semibold",
          description: "text-muted-foreground",
          actionButton: "bg-primary text-primary-foreground hover:bg-primary/90 rounded-xl",
          cancelButton: "bg-muted/50 text-muted-foreground hover:bg-muted/40 rounded-xl",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
